<template>
  <span
    v-if="disabled"
    :class="[sizeClasses, variantClasses]"
    class="l-ButtonLink l-BaseButton"
    data-test="link-disabled"
    disabled>
    <slot />
  </span>
  <a
    v-else-if="isExternalLink"
    :href="to"
    :class="[sizeClasses, variantClasses]"
    class="l-ButtonLink l-BaseButton"
    target="_blank"
    data-test="link">
    <slot />
  </a>
  <RouterLink
    v-else
    v-bind="$props"
    :class="[sizeClasses, variantClasses]"
    class="l-ButtonLink l-BaseButton"
    data-test="router-link">
    <slot />
  </RouterLink>
</template>

<script>
import { variants, sizes, propDefinitions } from '@/components/library/links/definitions';

/**
 * The approach to this component is taken from a vue-router v4
 * article - https://router.vuejs.org/guide/advanced/extending-router-link.html
 */
export default {
  name: 'ButtonLink',
  props: propDefinitions,
  computed: {
    isExternalLink() {
      return typeof this.to === 'string' && (this.to.startsWith('http') || this.to.startsWith('blob'));
    },
    sizeClasses() {
      return sizes[this.size];
    },
    variantClasses() {
      return variants[this.variant];
    },
  },
};
</script>

<style scoped>
.l-ButtonLink {
  @apply no-underline inline-block;
}
</style>
